<template>
  <cash-machine-status v-if="visible" v-bind="pluginProps" />
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { CashMachineInput } from './cashMachineStatus'
import { init } from './cashMachineStatus'
import CashMachineStatus from './CashMachineStatus.vue'

const visible = ref(false)
const pluginProps = ref()

function openCashMachine(props: CashMachineInput) {
  visible.value = true
  pluginProps.value = props

  return {
    close: () => {
      visible.value = false
    }
  }
}

init(openCashMachine)
</script>
